export var AgentTemplateVisibility;
(function (AgentTemplateVisibility) {
    AgentTemplateVisibility["Published"] = "published";
    AgentTemplateVisibility["Unlisted"] = "unlisted";
    AgentTemplateVisibility["Deleted"] = "deleted";
})(AgentTemplateVisibility || (AgentTemplateVisibility = {}));
//# sourceMappingURL=agent-template-visibility.const.js.map